import React from 'react';

const Loading = () => {
  return (
    <div className='loading-page'>
      <div className='bounceball'></div>
      <div className='loading-text'>now loading</div>
    </div>
  );
};

export default Loading;
